// Image effects (outline / shadow / glow / stroke / 3D bevel) — own implementation.
// Uses stacked CSS drop-shadow filters so effects follow the alpha shape of cutouts.

export const IMAGE_EFFECTS = [
  { id: "none", label: "None" },
  { id: "shadow", label: "Drop Shadow", color: true, size: true },
  { id: "glow", label: "Glow", color: true, size: true },
  { id: "outline", label: "Outline", color: true, size: true },
  { id: "stroke", label: "Stroke", color: true, size: true },
  { id: "bevel", label: "3D Bevel", color: true, size: true },
];

export function getImageFilter(el, scale = 1) {
  const e = el.imgEffect;
  if (!e || e === "none") return "none";
  const k = (el.imgEffectSize ?? 50) / 100;
  const c = el.imgEffectColor || "#ffffff";
  const px = (n) => +(n * scale).toFixed(2);

  if (e === "shadow") {
    const off = px(2 + 16 * k);
    const blur = px(4 + 22 * k);
    return `drop-shadow(${off * 0.7}px ${off * 0.7}px ${blur}px ${c})`;
  }
  if (e === "glow") {
    const blur = px(4 + 28 * k);
    return `drop-shadow(0 0 ${blur}px ${c}) drop-shadow(0 0 ${+(blur * 1.7).toFixed(2)}px ${c})`;
  }
  if (e === "outline" || e === "stroke") {
    const r = px(e === "stroke" ? 2 + 9 * k : 1 + 4 * k);
    const n = 16;
    const parts = [];
    for (let i = 0; i < n; i++) {
      const a = (i / n) * Math.PI * 2;
      parts.push(`drop-shadow(${(Math.cos(a) * r).toFixed(2)}px ${(Math.sin(a) * r).toFixed(2)}px 0 ${c})`);
    }
    return parts.join(" ");
  }
  if (e === "bevel") {
    const depth = Math.max(3, Math.round(4 + 10 * k));
    const parts = [`drop-shadow(${px(-1)}px ${px(-1)}px 0 rgba(255,255,255,0.55))`];
    for (let i = 1; i <= depth; i++) {
      parts.push(`drop-shadow(${px(i * 0.7)}px ${px(i * 0.7)}px 0 ${c})`);
    }
    parts.push(`drop-shadow(${px(depth * 0.7 + 3)}px ${px(depth * 0.7 + 3)}px ${px(7)}px rgba(0,0,0,0.45))`);
    return parts.join(" ");
  }
  return "none";
}
